import { useCallback, useState } from 'react';
import { useToast } from '@/hooks/useToast';
import metrics from '@/services/metrics';
const TIMEOUT = 2000;
let timeout;

const useDataAI = () => {
  const {
    addToast: sendNotification
  } = useToast();
  const {
    0: isGenerating,
    1: setGenerating
  } = useState(false);
  const generateData = useCallback(() => {
    setGenerating(true);
    if (timeout) clearTimeout(timeout);
    setTimeout(() => {
      sendNotification({
        type: 'error',
        description: "We're experiencing temporary outages with our AI Data generator, please check back again soon"
      });
      setGenerating(false);
      metrics.sendEvent('exp_ai_data_generate');
    }, TIMEOUT);
  }, [sendNotification]);
  return {
    isGenerating,
    generateData
  };
};

export default useDataAI;